import React, { Component } from 'react'
import { connect } from 'react-redux'
import placeholderIcon from '../../../../assets/images/placeholder-icon.svg'
import BkFlowRoomCardAdaDescription from '../accessiblity/BkFlowRoomCardAdaDescription'

import _ from 'lodash'

if (process.env.REACT_APP_COMPONENT_FEATURED_ICONS_COMPONENT === 'default') {
	require('../../../../styles/css/components/icons/bk-flow-featured-icons.css')
} else if (process.env.REACT_APP_COMPONENT_FEATURED_ICONS_COMPONENT === 'columns') {
	require('../../../../styles/css/components/icons/bk-flow-featured-icons-columns.css')
}

class BkFlowRoomFeaturedIcons extends Component {
	constructor(props) {
		super(props)
		this.state = {
			adaDescriptionExpanded: false
		}

		this.renderDetailIcons = this.renderDetailIcons.bind(this)
	}

	renderDetailIcons() {
		const {
			configData,
			roomGroup,
			roomData,
			availabilityData
		} = this.props
		const adaDetails = _.get(roomData, 'viewExtensions.adaDetails', null)
		let roomTypeFeaturedIcons = []

		const hotelLabels = _.get(configData, 'hotel.labels[0]', {})

		// construct featured amenities icons array
		if (
			roomData &&
			_.get(roomData, 'viewExtensions.roomAmenityIcons') &&
			!_.isEmpty(roomData.viewExtensions.roomAmenityIcons)
		) {
			const roomAmenities = roomData.viewExtensions.roomAmenityIcons
			for (const amenityKey in roomAmenities) {
				const currentAmenity = roomAmenities[amenityKey]

				if (currentAmenity.isFeatured) {
					roomTypeFeaturedIcons.push(currentAmenity)
				}
			}
		}

		let featuredIconTotal = roomTypeFeaturedIcons.length
		let renderIconData = []

		const hotelCode = availabilityData[0][0].basicPropertyInfo.hotelCode
		if (hotelCode.toString() === 'B7G6') { // Want to add to the top of the amenity list and show sq.ft first for Mondriane Gold Coast
			const roomSize = _.get(roomData, 'viewExtensions.roomSize')
			if (roomSize.value) {
				const sqft = _.get(roomSize, 'value')
				const sqm = Math.round(sqft * 0.092903)
				const roomSizePostfix = _.get(roomSize, 'approximate')
					? ` ${_.get(roomSize, 'approximate')}`
					: ''
				roomTypeFeaturedIcons.unshift({
					'@id': _.get(roomSize, '@id'),
					'@type': 'IconViewExtension',
					caption: '',
					description: '',
					filterable: false,
					isFeatured: false,
					name: `${sqm} sqm/${sqft} sq. ft${roomSizePostfix}`,
					path: _.get(roomSize, 'image.path')
				})
			}
		}

		for (let iconKey in roomTypeFeaturedIcons) {
			renderIconData.push(
				<div
					key={ roomTypeFeaturedIcons[iconKey].name.replace(/\s+/g, '-').toLowerCase() + ' ' + roomData.roomTypeCode + ' ' + roomGroup }
					className="bk-flow-room__featured-icon"
				>
					{ roomTypeFeaturedIcons[iconKey].path?
						<div className="bk-flow-room__featured-icon-src">
							<img className={ 'u-icon u-icon-' + roomTypeFeaturedIcons[iconKey].name.replace(/\s+/g, '-').toLowerCase() } src={ roomTypeFeaturedIcons[iconKey].path } alt={ roomTypeFeaturedIcons[iconKey].name }/>
						</div>
					:
						<div className="bk-flow-room__featured-icon-src">
							<img className={ 'u-icon u-icon-' + placeholderIcon } src={ placeholderIcon } alt={ roomTypeFeaturedIcons[iconKey].name } />
						</div>
					}

					{ roomTypeFeaturedIcons[iconKey].name &&
						<p className='u-font-small'>{ roomTypeFeaturedIcons[iconKey].name }</p>
					}
				</div>
			)
		}

		if (!_.isEmpty(renderIconData)) {
			let baseClassNames = 'bk-flow-room__featured-icons rows icons-' + featuredIconTotal

			if (process.env.REACT_APP_COMPONENT_FEATURED_ICONS_COMPONENT === 'columns') {
				baseClassNames = 'bk-flow-room__featured-icons columns icons-' + featuredIconTotal
			}

			const toggleAdaDescription = () => {
				this.setState({
					adaDescriptionExpanded: !this.state.adaDescriptionExpanded
				})
			}

			return (
				<div className={baseClassNames}>
					{ renderIconData }
					{ adaDetails &&
						<BkFlowRoomCardAdaDescription
							adaDisclaimer={ adaDetails }
							hotelLabels={hotelLabels}
							toggledState={ this.state.adaDescriptionExpanded}
							toggleEvent={toggleAdaDescription}
						/>
					}
				</div>
			)
		} else {
			return null
		}
	}

	render() {
		return (
			this.renderDetailIcons()
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		availabilityData: state.availabilityData.availability,
	}
}

export default connect(mapStateToProps, null)(BkFlowRoomFeaturedIcons)


// WEBPACK FOOTER //
// ./src/components/room/elements/icons/BkFlowRoomFeaturedIcons.js